module.exports = __webpack_public_path__ + "static/media/BALMSTICK.8ab9e028.png";